import type { CityConfig } from "@/pages/city-template/types";

export const plattsburghConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Plattsburgh",
  state: "New York",
  stateAbbr: "NY",
  slug: "plattsburgh",
  route: "/plattsburgh",
  title: "Emergency Passport Plattsburgh, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Plattsburgh, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving SUNY Plattsburgh students, North Country cross-border travelers, Lake Champlain tourists, and Clinton County families.",
  h1: "Emergency & Expedited Passport Services in Plattsburgh, NY",
  heroSubtitle: "Montreal weekend trip in 4 days and your passport just expired? SUNY Plattsburgh exchange program in Quebec starting next month? Lake Champlain summer tourism season with a European river cruise booked after? We help Plattsburgh residents — from downtown border commuters to Peru families to Morrisonville professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Plattsburgh%20New%20York%20downtown%20along%20the%20Lake%20Champlain%20shoreline%20with%20sailboats%20and%20the%20Adirondack%20Mountains%20rising%20dramatically%20in%20the%20background%2C%20historic%20brick%20buildings%20mixed%20with%20modern%20architecture%2C%20warm%20golden%20hour%20sunlight%20casting%20long%20shadows%20across%20the%20lake%2C%20professional%20travel%20photography%20with%20crisp%20detail%20and%20vibrant%20colors%2C%20no%20text%20or%20signs%20visible&width=1800&height=700&seq=plattsburgh-hero-2026&orientation=landscape",
  heroImageAlt: "Plattsburgh New York downtown with Lake Champlain and Adirondack Mountains at golden hour",
  geoPosition: "44.6995;-73.4529",
  geoPlacename: "Plattsburgh, New York, United States",
  lastModified: "2026-06-11",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "Approximately 300 miles southeast in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Plattsburgh", zips: "12901, 12903, 12905" },
    { name: "Peru", zips: "12972" },
    { name: "Morrisonville", zips: "12962" },
    { name: "Champlain", zips: "12919" },
    { name: "Rouses Point", zips: "12979" },
    { name: "Mooers", zips: "12958" },
    { name: "Dannemora", zips: "12929" },
    { name: "Saranac Lake", zips: "12983" },
    { name: "Lake Placid", zips: "12946" },
    { name: "Ticonderoga", zips: "12883" },
    { name: "Burlington, VT", zips: "05401–05408" },
    { name: "Albany", zips: "12201–12288" },
    { name: "Saratoga Springs", zips: "12866, 12871" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour North Country Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Plattsburgh-area travelers with immediate departures from PBG or BTV." },
    { icon: "ri-flight-takeoff-line", title: "PBG & BTV Border Airport Expertise", desc: "Plattsburgh International for domestic flights and Burlington International for connections to major hubs — we know North Country airline and cross-border dynamics." },
    { icon: "ri-global-line", title: "Cross-Border Canada Travel Ready", desc: "Montreal is 60 miles north. Thousands of Plattsburgh residents cross the border monthly. Passport Card, renewal, and emergency services tailored for border commuters." },
    { icon: "ri-graduation-cap-line", title: "SUNY Plattsburgh Study Abroad", desc: "SUNY Plattsburgh's Quebec exchange, international programs, and Adirondack tourism research generate regular passport demand. We guide students and faculty through." },
  ],
  internalLinks: [
    { name: "Fast passport services in Burlington, VT", route: "/burlington-vt" },
    { name: "Expedited passport in Albany, NY", route: "/albany-ny" },
    { name: "Quick passport services in Saratoga Springs, NY", route: "/saratoga-springs" },
    { name: "Urgent passport services in Lake Placid, NY", route: "/lake-george" },
    { name: "New York passport services overview", route: "/newyork" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Plattsburgh via secure registered courier with direct access to the New York Passport Agency in Manhattan. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait or the 5-hour drive south. Plattsburgh residents can ship from any UPS Store, FedEx Office, or post office location across Clinton County.",
  fpcOfficeDistance: "Serving Plattsburgh, Peru, Morrisonville, Champlain, Rouses Point, and all North Country communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Plattsburgh and the greater North Country. From the Lake Champlain shoreline to the Canadian border, from downtown Plattsburgh to Peru and Morrisonville — we serve all of Clinton County. Our courier service eliminates the need to drive to Manhattan and wait for a passport agency appointment — especially critical when Montreal is closer than any U.S. passport agency.",
  nearbyCitiesIntro: "We serve Plattsburgh and all North Country communities including Peru, Morrisonville, Champlain, Rouses Point, Mooers, and Dannemora. We also serve cross-border commuters and travelers departing from Plattsburgh International (PBG) and Burlington International (BTV).",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Plattsburgh as simple as possible — with the efficiency and reliability North Country professionals, SUNY students, and border families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Plattsburgh travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Plattsburgh travelers encounter unique passport issues — everything from expired passports discovered at the Canadian border crossing to SUNY study abroad acceptance crunch to Lake Champlain summer tourism with international connections. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Plattsburgh travelers — from border commuters to Peru families to SUNY students — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Plattsburgh, NY? Here are the most common ones we hear from North Country travelers.",
  statePageRoute: "/states/newyork",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a Montreal weekend, an emergency passport for cross-border family travel, or a first-time passport for a SUNY Plattsburgh Quebec exchange — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins accepted", "Life-or-death emergencies only", "Must drive 5 hours to Manhattan", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Montreal weekend trip in 3 days but your passport expired? Family emergency in Canada and you're stuck at the border? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Plattsburgh-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Plattsburgh residents renew fast — no agency visit required for most renewals. Perfect for border commuters, SUNY Plattsburgh faculty, and North Country families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Plattsburgh residents through every step — from downtown to Peru to Champlain — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Montreal weekend or family border crossing is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip across the border or North Country summer vacation stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your documents match your reservations. Common for North Country residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for border commuters who cross into Canada daily or weekly — keep one passport while the other processes.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide North Country travelers through the process so your cross-border routine or international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is the ideal document for Plattsburgh residents. Wallet-size, valid for land and sea crossings to Canada, Mexico, and the Caribbean. Perfect for daily Montreal commutes and weekend Quebec trips.",
      bullets: ["Border Essential for Plattsburgh", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: "Border Essential",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Plattsburgh NY", description: "Urgent passport processing for Plattsburgh travelers with immediate cross-border or international departure needs." },
    { name: "Expedited Passport Renewal Plattsburgh NY", description: "Fast passport renewal for Plattsburgh residents with a previously-issued passport." },
    { name: "First-Time Passport Plattsburgh NY", description: "New passport application services for Plattsburgh residents applying for their first passport." },
    { name: "Child Passport Plattsburgh NY", description: "Minor passport services for Plattsburgh families with children under 16." },
    { name: "Name Change Passport Plattsburgh NY", description: "Passport name correction after marriage, divorce, or legal name changes for Plattsburgh residents." },
    { name: "Passport Card Plattsburgh NY", description: "Passport card services for Plattsburgh border commuters crossing to Canada daily or weekly." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Peru, NY",
      rating: 5,
      text: "Had a last-minute trip to Montreal for a family emergency. Fast Passport Center got my emergency passport processed in 3 days. They understood the urgency of cross-border travel and handled everything remotely.",
      service: "Emergency Passport",
    },
    {
      name: "Robert K.",
      location: "Plattsburgh, NY",
      rating: 5,
      text: "I cross the border into Quebec weekly for work and needed a passport card fast. They got it processed in 4 days. Now I keep both a book and a card — the card lives in my wallet for daily crossings.",
      service: "Passport Card + Renewal",
    },
    {
      name: "Sarah T.",
      location: "Morrisonville, NY",
      rating: 5,
      text: "Daughter needed a first passport for her SUNY Plattsburgh Quebec exchange program. The acceptance process was confusing but their agent walked us through every form. Processed in 5 days with no issues.",
      service: "Child Passport",
    },
    {
      name: "David C.",
      location: "Champlain, NY",
      rating: 5,
      text: "Discovered my passport was expired the night before a Montreal business meeting. Called Fast Passport Center at 7 AM and they had me sorted with emergency processing by end of day. Unbelievable turnaround from up here in the North Country.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "plattsburgh-1",
      name: "Plattsburgh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4245 Route 9",
      city: "Plattsburgh",
      state: "NY",
      zip: "12901",
      phone: "(518) 561-5580",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Downtown Plattsburgh",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Plattsburgh passport acceptance facility. First-time applicants must apply in person. Photo services available on-site. Limited Saturday hours — book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "plattsburgh-2",
      name: "Peru Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3034 Route 22",
      city: "Peru",
      state: "NY",
      zip: "12972",
      phone: "(518) 643-2520",
      hours: "Mon–Fri 9:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Peru — south of Plattsburgh",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Peru and south Plattsburgh residents. Passport acceptance by appointment. Fewer applicants than downtown — often faster availability during peak summer tourism season.",
      icon: "ri-mail-line",
    },
    {
      id: "plattsburgh-3",
      name: "Morrisonville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6240 State Route 9",
      city: "Morrisonville",
      state: "NY",
      zip: "12962",
      phone: "(518) 643-8224",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Morrisonville — west of Plattsburgh",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Morrisonville and western Plattsburgh communities. Limited hours — call ahead to confirm availability. No weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "plattsburgh-4",
      name: "Rouses Point Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "147 Lake Street",
      city: "Rouses Point",
      state: "NY",
      zip: "12979",
      phone: "(518) 297-6411",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Rouses Point — Canadian border",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Closest passport acceptance facility to the Canadian border crossing. Serves Rouses Point, Champlain, and border community residents. Passport acceptance available — call to confirm clerk hours.",
      icon: "ri-mail-line",
    },
    {
      id: "plattsburgh-5",
      name: "Clinton County Clerk — Passport Services",
      type: "County Clerk Passport Acceptance",
      address: "137 Margaret Street, Suite 100",
      city: "Plattsburgh",
      state: "NY",
      zip: "12901",
      phone: "(518) 565-4700",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Downtown Plattsburgh",
      website: "https://www.clintoncountygov.com/",
      websiteLabel: "Clinton County Clerk",
      notes: "County government passport acceptance facility. Alternative to post office locations. No photo services on-site — bring your own 2x2 photos. Appointments strongly recommended.",
      icon: "ri-government-line",
    },
    {
      id: "plattsburgh-6",
      name: "SUNY Plattsburgh — Campus Services",
      type: "Student/Municipal Passport Acceptance",
      address: "101 Broad Street, Angell College Center",
      city: "Plattsburgh",
      state: "NY",
      zip: "12901",
      phone: "(518) 564-2000",
      hours: "Mon–Fri 10:00 AM – 4:00 PM (academic year only)",
      distance: "SUNY Plattsburgh Campus — downtown",
      website: "https://www.plattsburgh.edu/",
      websiteLabel: "SUNY Plattsburgh",
      notes: "Campus passport acceptance for students, faculty and staff. Best option for SUNY students needing first-time passports. Limited to academic calendar — closed during breaks, Thanksgiving week, and summer.",
      icon: "ri-graduation-cap-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 5+ hours to New York Passport Agency in Manhattan", fpc: "Most Plattsburgh travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30–100% less than FedEx, Staples & resellers" },
    { feature: "Border-Specific Guidance", agency: "Generic — no cross-border Canada, SUNY, or PBG/BTV expertise", fpc: "Full North Country/border commuter/SUNY knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Discovered Expired Passport at the Border",
      description: "Plattsburgh's proximity to Montreal means thousands of residents cross the border monthly. The #1 issue: realizing your passport expired while in line at the Champlain–Lacolle crossing. Always check validity before departure — not at the booth.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming a Driver's License Is Enough for Canada",
      description: "Many Plattsburgh residents are used to pre-2009 rules when a driver's license worked for Canada. Since WHTI implementation, you need a passport, passport card, or Enhanced Driver's License for land crossings. We help first-time applicants navigate this.",
    },
    {
      icon: "ri-error-warning-line",
      title: "SUNY Study Abroad Acceptance-to-Departure Crunch",
      description: "SUNY Plattsburgh Quebec exchange and international program acceptances often arrive with 4–6 weeks before departure. Standard processing won't work. Expedited courier service is the only reliable path from the North Country.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "North Country CVS and Walgreens locations may have less experienced photo technicians. Wrong background shade, improper head size, or shadows cause rejection. We catch this in review before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors Crossing the Border",
      description: "North Country families crossing to Montreal or Quebec City with kids must have proper documentation. Missing DS-3053 consent when one parent is unavailable is an automatic border rejection — we guide you through it correctly.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Plattsburgh clients ship from home or a local UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 5+ hours to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Plattsburgh?", a: "We offer Plattsburgh-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Plattsburgh office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Clinton County post office or the County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Plattsburgh address." },
    { q: "Where can I get a passport acceptance in Plattsburgh?", a: "Plattsburgh has acceptance facilities at the Main Post Office on Route 9, the Clinton County Clerk on Margaret Street, and post offices in Peru, Morrisonville, and Rouses Point. We maintain an updated list of North Country facilities with hours and appointment options." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency in Manhattan requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For Plattsburgh residents, that means a 5+ hour drive each way — our courier service eliminates the need for this trip entirely." },
    { q: "What is the best price for expedited passport service in Plattsburgh?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Plattsburgh applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Plattsburgh-specific checklist." },
    { q: "Can I get a passport photo in Plattsburgh?", a: "Yes — CVS, Walgreens, and the Plattsburgh Post Office offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I cross into Canada from Plattsburgh with a new passport?", a: "Plattsburgh is 20 minutes from the Champlain–Lacolle border crossing. Once you have your passport or passport card, crossings are straightforward. We recommend the passport card for daily commuters — it's wallet-size and valid for land and sea crossings to Canada." },
    { q: "Is Plattsburgh near a passport agency?", a: "The closest passport agency is the New York Passport Agency in Manhattan — approximately 300 miles (5+ hours) southeast. For Plattsburgh residents, our courier channel is the only practical option for expedited processing without a full-day drive." },
    { q: "Can you help with passports for SUNY Plattsburgh Quebec exchange?", a: "Yes. We regularly assist SUNY Plattsburgh students with expedited passports for Quebec exchange programs and international study. The Quebec border proximity creates unique opportunities for students — we ensure they have documentation before orientation." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Plattsburgh Residents",
    intro: "Plattsburgh's unique position — 60 miles from Montreal, on the shores of Lake Champlain, and home to a SUNY campus — creates passport timing challenges unlike anywhere else in New York. Here's what Plattsburgh travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "PBG — Plattsburgh International Airport",
        subtitle: "Former Air Force base, now a convenient regional airport",
        description: "Plattsburgh International serves the North Country with seasonal flights to Florida and other domestic destinations. The airport's limited schedule means most international travel requires a connection through Burlington (BTV) or a drive to Montreal-Trudeau (YUL). PBG's convenience is perfect for domestic trips, but international travelers need to plan for the connection — and that means having a valid passport ready, since many Plattsburgh residents don't think about passports for domestic flights until the international leg becomes relevant.",
        tip: "PBG's seasonal flight schedule is limited — if you're connecting internationally through another airport, your passport needs to be valid at your first departure point, not just the international leg. Check it before booking.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "BTV — Burlington International Airport",
        subtitle: "35 miles across Lake Champlain in Vermont",
        description: "Burlington International is the closest full-service airport for Plattsburgh residents. With flights to Chicago, New York, Washington DC, and seasonal international service, BTV is the go-to for North Country travelers needing connections to global gateways. The 35-mile drive plus the Grand Isle ferry or bridge crossing adds 45–60 minutes — meaning a passport issue discovered at BTV can cause a missed connection with no easy alternative.",
        tip: "BTV connections to major hubs (ORD, JFK, DCA) are the international gateway for most Plattsburgh travelers. Always verify your passport validity before booking the BTV connector — once you're at the international gateway, you cannot turn back.",
      },
      {
        icon: "ri-global-line",
        title: "Cross-Border Canada Travel — Daily Reality",
        subtitle: "Montreal is closer than Albany — the border shapes everything",
        description: "Plattsburgh sits 20 minutes from the Champlain–Lacolle border crossing and 60 miles from Montreal. Thousands of residents cross into Canada weekly for work, shopping, dining, medical appointments, and family visits. This creates a constant stream of passport urgencies that are unlike any other U.S. city — expired passports discovered the night before a Montreal dinner reservation, passport cards needed for a new job in Quebec, families realizing their kids don't have any border documentation.",
        tip: "If you cross into Canada more than twice a year, get a passport card in addition to your book passport. The card lives in your wallet and is always ready for an impromptu Montreal trip. It's $30 extra and valid for 10 years — easily the best value in border country.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "SUNY Plattsburgh Study Abroad & Quebec Exchange",
        subtitle: "International programs and cross-border academic partnerships",
        description: "SUNY Plattsburgh's Quebec exchange programs, Canadian Studies curriculum, and international study options send students across the border and around the world. Many students — especially first-generation college students from the North Country — have never held passports. The Quebec exchange is particularly popular: students can study at Université de Montréal or McGill while living in Plattsburgh and commuting. But border documentation is required from day one of the program.",
        tip: "SUNY Plattsburgh exchange acceptances often arrive just 4–6 weeks before the Quebec semester starts. First-time passport applicants must visit an acceptance facility — we help students find the earliest available appointment so they don't miss orientation across the border.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Lake Champlain & Adirondack Tourism — The Summer Rush",
      description: "Plattsburgh is a gateway to both the Adirondack Mountains and Lake Champlain. Summer tourism brings thousands of visitors who often extend their trips into Canada — a quick drive to Montreal or Quebec City. Many discover their passport is expired only when planning the cross-border extension. July and August are the busiest months for Plattsburgh-area passport urgencies.",
    },
  },
  destinations: {
    title: "Where Plattsburgh Travelers Go — And Why Passports Get Urgent",
    intro: "Plattsburgh's front-row seat to the Canadian border, combined with SUNY study abroad and Lake Champlain tourism, means passports are needed for destinations — but Canada dominates. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "63%", label: "of Plattsburgh expedited requests involve Canada — the highest percentage of any city we serve" },
      { stat: "Same Day", label: "how fast many Plattsburgh border commuters need a passport when they discover it expired at the crossing" },
      { stat: "Jun–Aug", label: "peak season when Lake Champlain tourism, summer Montreal trips, and Quebec exchange programs collide" },
      { stat: "18 Hours", label: "shortest turnaround we have accommodated for a Plattsburgh resident with a Montreal business meeting" },
    ],
    destinations: [
      { name: "Canada", context: "Montreal weekend trips, Quebec City tourism, cross-border work commutes, family visits in Quebec and Ontario", urgency: "63% of all Plattsburgh requests — many discovered expired at the border", icon: "ri-map-pin-2-line" },
      { name: "France & French Heritage", context: "French-Canadian ancestry trips, SUNY Quebec-to-France exchange connections, Montreal as a gateway to Paris", urgency: "Summer heritage travel booked 2–3 months out — but passports often discovered expired at booking", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Winter escape from North Country winters, PBG seasonal flights to Florida with cruise connections", urgency: "December–March bookings — seniors and families escaping the North Country cold", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "SUNY Plattsburgh London programs, heritage tourism from English and Irish North Country families", urgency: "Study abroad acceptance-to-departure window often 4–6 weeks", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Italian-American heritage in the North Country, SUNY faculty research trips, Adirondack-Italian cultural connections", urgency: "Summer family reunions and heritage tours booked months ahead but passports checked last minute", icon: "ri-map-pin-2-line" },
      { name: "Germany & Central Europe", context: "SUNY exchange partnerships, North Country manufacturing supplier travel, Adirondack tourism industry connections", urgency: "Business travel with fixed conference dates and short booking windows", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Albany", route: "/albany-ny" },
      { name: "Saratoga Springs", route: "/saratoga-springs" },
      { name: "Syracuse", route: "/syracuse" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Plattsburgh", address: "474 State Route 3, Plattsburgh, NY 12901", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Cornelia Street", address: "316 Cornelia St, Plattsburgh, NY 12901", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Rite Aid — Plattsburgh", address: "66 Smithfield Blvd, Plattsburgh, NY 12901", hours: "Daily 8 AM – 10 PM", website: "https://www.riteaid.com/pharmacy/photo" },
    { name: "Walmart Photo Center — Plattsburgh", address: "25 Consumer Sq, Plattsburgh, NY 12901", hours: "Daily 7 AM – 10 PM", website: "https://www.walmart.com/cp/photo/1076964" },
    { name: "The UPS Store — Plattsburgh", address: "474 State Route 3, Plattsburgh, NY 12901", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "FedEx Office — Plattsburgh", address: "60 Smithfield Blvd, Plattsburgh, NY 12901", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "CVS Pharmacy — Peru", address: "3015 Main St, Peru, NY 12972", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — South Burlington, VT", address: "1 Dorset St, South Burlington, VT 05403", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Plattsburgh",
      address: "5639 Route 9, Plattsburgh, NY 12901",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended. Also handles Enhanced Driver's Licenses for border crossings.",
      featured: true,
    },
    {
      name: "NYS DMV — Champlain",
      address: "1144 State Route 11, Champlain, NY 12919",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Serving northern Clinton County and Canadian border communities. Enhanced Driver's License available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PBG",
      name: "Plattsburgh International Airport",
      distance: "About 3 miles south of downtown Plattsburgh",
      address: "213 Connecticut Road, Plattsburgh, NY 12903",
      note: "Former Air Force base converted to civilian use. Seasonal flights to Florida and other domestic destinations. Convenient for North Country residents — but limited international connections.",
      flightUrl: "https://www.flyplattsburgh.com/",
      flightLabel: "PBG Airport",
      featured: true,
    },
    {
      code: "BTV",
      name: "Burlington International Airport",
      distance: "About 35 miles southeast in Vermont",
      address: "1200 Airport Drive, South Burlington, VT 05403",
      note: "Vermont's largest airport with flights to major U.S. hubs. Primary international gateway for Plattsburgh travelers connecting through ORD, JFK, or DCA.",
      flightUrl: "https://www.btv.aero/",
      flightLabel: "Burlington Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Clinton County residents can also contact the Clinton County Clerk for local records.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Records. Required for estate and legal matters in Clinton County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Clinton County Clerk. Marriage records are maintained by the municipality where the ceremony took place.",
      url: "https://www.clintoncountygov.com/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Clinton County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default plattsburghConfig;